import { Component, ViewChild } from '@angular/core';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { HolidayService } from '../../../Model/Holiday/holiday.service';
import { CommonService } from '../../../Model/Common/common.service';
import { ComboService } from '../../../Model/Combo/combo.service';
import { NgbModal, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import moment from 'moment';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { parse } from 'path';

interface SiteHoliday {
  ClientGroupName: string
  Date: string
  ESS_ClientWiseStateHolidayMasterID: number
  ESS_CompanyHolidayMasterID: number
  ESS_HolidayMasterID: number
  ESS_StateHolidayMasterID: number
  HolidayName: string
  SiteName: string
  StateName: string
  TypesOfLeave: string
  Year: string
}

@Component({
  selector: 'app-site-holiday',
  standalone: true,
  imports: [DataTablesModule, CommonModule, FormsModule, NgbNavModule, NgSelectModule, RouterModule, LoaderComponent],
  templateUrl: './site-holiday.component.html',
  styleUrl: './site-holiday.component.scss'
})
export class SiteHolidayComponent {
  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective
  active = 1;
  SiteHolidayData: SiteHoliday[] = [];
  isDisabled: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  ClientsFilter = [] as any;
  StatesFilter = [] as any;
  SitesFilter = [] as any;
  Years = [] as any;
  TypesOfLeaves = ['NA', 'Compulsory', 'Optional'];

  DisablesFilter = {
    Year: false,
  }

  filter = {
    SelectType: 4,
    Year: null,
    StateId: null,
    StateIdObj: null,
    ClientId: null as any,
    SiteId: null as any,
    SiteIdObj: null as any,
    TypesOfLeave: null,
    ESS_SiteOnClientHolidayMasterID: null as any
  }
  HolidayMappingDetail = {
    SelectType: 'Insert',
    ESS_SiteHolidayMasterID: 0,
    ESS_CompanyHolidayMaster: [],
  }
  dtoptions: DataTables.Settings = {};
  constructor(
    private holiday: HolidayService,
    protected common: CommonService,
    private combo: ComboService,
    private modalService: NgbModal,
    private toast: ToastService,
    private utility: UtilityService,
    private router: Router,
    private route: ActivatedRoute,
    private tooltip: TooltipService
  ) {
    this.common.getPageRights();
    this.route.params.subscribe(params => this.filter.ESS_SiteOnClientHolidayMasterID = parseInt(params['id']));
    if (this.filter.ESS_SiteOnClientHolidayMasterID > 0) {
      this.DisablesFilter = {
        Year: true,
      }
    }
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    if (this.filter.ESS_SiteOnClientHolidayMasterID > 0) {
      this.GetSiteHoliday();
    }
    this.SelectDate('RegistrationDate', null, null);
    this.ComboLoad('State');
  }
  
  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    this.combo.ComboLoad({ 'Combotype': Combotype, 'BranchId': 0, 'ClientId': this.filter.ClientId, 'SiteId': 0, 'DesignationId': 0, 'EmpType': null, 'StateId': this.filter.StateId, 'DistrictId': 0, 'EmpMasterID': 0, Year: this.filter.Year }).subscribe({
      next: (response) => {
        if (Combotype == 'State') {
          this.StatesFilter = response.ComboLoad;
          this.ClientsFilter = []
          this.SitesFilter = []
        } else if (Combotype == 'ClientLoadOnStateId') {
          this.ClientsFilter = response.ComboLoad;
          this.SitesFilter = []
        } else if (Combotype == 'ClientWiseSite') {
          this.SitesFilter = response.ComboLoad;
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetSiteHoliday() {
    this.isDisabled = true;
    try {
      if (this.filter.SiteIdObj.length) {
        this.filter.SiteId = this.filter.SiteIdObj.toString();
      } else {
        this.filter.SiteId = null;
      }
    } catch (e) {
      this.filter.SiteId = null;
    }

    this.holiday.GetSiteHoliday(this.filter).subscribe({
      next: (response) => {
        if (this.filter.ESS_SiteOnClientHolidayMasterID > 0) {
          if (this.filter.Year == null) {
            this.filter.Year = response.Table1[0].Year;
          }
          if (this.filter.StateId == null || this.filter.StateId == 0) {
            this.filter.StateId = response.Table1[0].StateMasterID;
          }

          if (this.filter.ClientId == null || this.filter.ClientId == 0) {
            this.ComboLoad('ClientLoadOnStateId')
            this.filter.ClientId = response.Table1[0].ClientId;
          }


          //this.filter.SiteIdObj = response.Table1.map((e: any) => parseInt(e.SiteId));
          if (this.filter.SiteIdObj == null || this.filter.SiteIdObj.length == 0) {
            this.ComboLoad('ClientWiseSite');
            this.filter.SiteIdObj = [];
            response.Table1[0]['SiteId'].split(',').forEach((element: any) => {
              this.filter.SiteIdObj.push(parseInt(element));
            });
          }
          this.HolidayMappingDetail.SelectType = "Update";
        }

        this.HolidayMappingDetail.ESS_CompanyHolidayMaster = response.Table;
        this.SiteHolidayData = Object.values(response.Table)
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });

        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  // LoadSiteHoliday() {
  //   this.isDisabled = true;
  //   this.holiday.GetSiteHoliday({ SelectType: 3, Year: this.filter.Year, ESS_SiteOnClientHolidayMasterID: this.filter.ESS_SiteOnClientHolidayMasterID }).subscribe({
  //     next: (response) => {
  //       this.filter.Year = response.Table1[0].Year;
  //       this.filter.StateId = response.Table1[0].Stateid;
  //       this.ComboLoad('StateWiseClient')
  //       this.filter.ClientId = response.Table1[0].ClientId;
  //       this.ComboLoad('ClientWiseSite');
  //       const clientIdsString = response.Table1.map((e: any) => e.SiteId)[0];
  //       const clientIdsArray = clientIdsString.split(',').map(Number);
  //       this.filter.SiteIdObj = clientIdsArray;
  //       this.HolidayMappingDetail.SelectType = "Update";
  //       this.HolidayMappingDetail.ESS_SiteHolidayMaster = response.Table;
  //       this.SiteHolidayData = Object.values(response.Table)
  //       this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
  //         dtInstance.destroy();
  //         this.dtTrigger.next(null);
  //       });


  //       this.isDisabled = false;
  //     },
  //     complete: () => { },
  //     error: (error) => {
  //       this.isDisabled = false;
  //     },
  //   });
  // }

  async SaveSiteHoliday() {
    await this.common.getPageRights();
    if (this.filter.Year == null || this.filter.Year == '') {
      this.toast.show({ message: 'Please select year', type: toastTypeEnum.warning });
    } else if (this.filter.StateId == null || this.filter.StateId == '' || this.filter.StateId == 0 || this.filter.StateId == '0') {
      this.toast.show({ message: 'Please select state', type: toastTypeEnum.warning });
    } else if (this.filter.ClientId == null || this.filter.ClientId == '' || this.filter.ClientId == 0 || this.filter.ClientId == '0') {
      this.toast.show({ message: 'Please select client', type: toastTypeEnum.warning });
    } else if (this.filter.SiteIdObj == null || this.filter.SiteIdObj == '' || this.filter.SiteIdObj.length == 0) {
      this.toast.show({ message: 'Please select client', type: toastTypeEnum.warning });
    } else {
      if (this.HolidayMappingDetail.ESS_CompanyHolidayMaster.length > 0) {
        const modalRef = this.modalService.open(ConfirmationComponent, {
          size: 'md',
          backdrop: 'static',
          centered: true,
          windowClass: 'confirmation-modal'
        });
        modalRef.componentInstance.Message = this.HolidayMappingDetail.ESS_CompanyHolidayMaster.filter((e: any) => this.common.ToLowerCase(e.TypesOfLeave) == 'compulsory' || this.common.ToLowerCase(e.TypesOfLeave) == 'optional').length > 0 ? 'Do you want to save?' : 'All NA Holiday Type Will be Deleted. Do you want to delete?';
        modalRef.result.then((result: any) => {
          if ((this.common.PageRight.IsAdd && this.filter.ESS_SiteOnClientHolidayMasterID == 0) || (this.common.PageRight.IsEdit && this.filter.ESS_SiteOnClientHolidayMasterID > 0)) {
            if (result) {
              this.isDisabled = true;
              this.HolidayMappingDetail.ESS_CompanyHolidayMaster.forEach((element: any) => {
                element.ESS_SiteWiseClientHolidayMasterID = this.filter.ESS_SiteOnClientHolidayMasterID;
                element.StateId = this.filter.StateId;
                element.ClientId = this.filter.ClientId;
                element.Year = this.filter.Year;
                element.SiteId = this.filter.SiteIdObj.toString();
              });
              this.holiday.SaveSiteHoliday(this.HolidayMappingDetail).subscribe({
                next: (response) => {
                  if (response.Error_Code == '38') {
                    this.filter.Year == null;
                    this.filter.StateId == null;
                    this.filter.StateIdObj == null;
                    this.filter.ClientId == null;
                    this.filter.SiteId == null;
                    this.filter.SiteIdObj == null;

                    const modalRef = this.modalService.open(AlertSuccessComponent, {
                      size: 'md',
                      backdrop: 'static',
                      centered: true,
                      windowClass: 'confirmation-modal'
                    });
                    modalRef.componentInstance.Message = response.Error_Message;
                    modalRef.result.then((result: any) => {
                      if (result) {
                        this.close();
                      }
                    });
                  }
                  else {
                    const modalRef = this.modalService.open(AlertWarningComponent, {
                      size: 'md',
                      backdrop: 'static',
                      centered: true,
                      windowClass: 'confirmation-modal'
                    });
                    modalRef.componentInstance.Message = response.Error_Message;
                    modalRef.result.then((result: any) => { });
                  }
                  this.isDisabled = false;
                },
                complete: () => { },
                error: (error) => {
                  this.isDisabled = false;
                },
              });
            }
          } else {
            this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
          }
        }).catch(() => {
          // Modal dismissed
        });
      } else {
        this.toast.show({ message: 'Please select holidays', type: toastTypeEnum.warning });
      }
    }
  }

  Validate(form: any) {
    if (form.valid) {
      if (this.filter.Year && this.filter.StateId && this.filter.ClientId && this.filter.SiteIdObj && this.filter.SiteIdObj.length > 0) {
        this.GetSiteHoliday();
      }
    }
    else {
      form.submitted = true;
    }
  }

  ClearSiteClient() {
    this.SiteHolidayData = [];
    this.filter.ClientId = null;
    this.filter.SiteIdObj = null;
    this.ClientsFilter = [];
    this.SitesFilter = [];
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
    this.HolidayMappingDetail.ESS_CompanyHolidayMaster = [];
  }

  ClearSite() {
    this.SiteHolidayData = [];
    this.filter.SiteIdObj = null
    this.SitesFilter = [];
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
    this.HolidayMappingDetail.ESS_CompanyHolidayMaster = [];
  }

  ClearHolidays() {
    this.SiteHolidayData = [];
    this.ClientsFilter = [];
    this.SitesFilter = [];

    this.filter.ClientId = null;

    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
    this.HolidayMappingDetail.ESS_CompanyHolidayMaster = [];
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        console.log(response);
        if (SelectType == 'RegistrationDate') {
          this.Years = [moment(response.Table[0].RegistrationDate.RegistrationDate).year() - 1, moment(response.Table[0].RegistrationDate).year(), moment(response.Table[0].RegistrationDate).year() + 1];
          console.log("year", this.Years);

        }
      },
      complete: () => { },
      error: (error) => { },
    });
  }

  CheckAll(event: any, Type: String) {
    if (Type == 'Site') {
      if (event.target.checked) {
        console.log(this.SitesFilter);
        this.filter.SiteIdObj = this.SitesFilter.filter((e: any) => e.ESS_SiteOnClientHolidayMasterId == this.filter.ESS_SiteOnClientHolidayMasterID || e.ESS_SiteOnClientHolidayMasterId == null || e.ESS_SiteOnClientHolidayMasterId == 0).map((e: any) => e.SiteMasterID);
      } else {
        this.filter.SiteIdObj = [];
      }
    }
  }

  CheckDiselect() {
    if (this.filter.SiteIdObj != null) {
      const SiteIdObjfilter = [] as any;
      this.filter.SiteIdObj.forEach((element: any) => {
        if (this.SitesFilter.filter((e: any) => this.common.ToLowerCase(e.IsClientMapped) == 'mapped' && e.ESS_SiteOnClientHolidayMasterId != this.filter.ESS_SiteOnClientHolidayMasterID).map((e: any) => e.SiteMasterID).filter((e: any) => e == element).length == 0) {
          SiteIdObjfilter.push(element);
        }
      });
      this.filter.SiteIdObj = SiteIdObjfilter;
    }
  }

  close() {
    this.router.navigate(['/master/holiday/site']);
  }
}
